import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import IconLoading from "assets/images/icons/project-icons/loading.gif";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import ComplianceHeader from "components/__new/compliance/ComplianceHeader";
// import { ButtonLoader } from "components/__new/common/form";
import useLoginInfo from "hooks/useLoginInfo";
import * as complianceActions from "store/entities/compliance/action";
import * as accountActions from "store/auth/account/action";


const ApprovalPending = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const { employerInfo } = useSelector((s) => s.auth.account);
    
    useEffect(() => {
        if (userInfo.employer.isCompliant === true){
            history.push("/compliance/approval/success");
        }
        dispatch(complianceActions.updateComplianceProgress(100));
        // eslint-disable-next-line
    }, [])
    
    useEffect(() => {
        if (employerInfo?.status === "success"){
            dispatch(accountActions.updateLoggedInPersistedStorage({ ...employerInfo?.data?.employer }));
        }
        // eslint-disable-next-line
    }, [employerInfo])
    
    return (
        <div>
            
            <DynamicHeadTag
                headerText="Earnipay Compliance"
                headerDescription="Complete each step to access all Earnipay features"
            />
            
            <ComplianceHeader />
            
            <div className="pt-6 px-6 pb-24 sm:pt-10 sm:px-10">
                <div className="w-full max-w-2xl mx-auto box py-14">
                    <div className="w-full max-w-sm mx-auto text-center flex flex-col items-center">
                        
                        <div className="w-48 h-48">
                            <img src={IconLoading} alt="loading" />
                        </div>
                        
                        <div className="text-ep-primary font-bold text-lg">
                            Please wait while we approve your account
                        </div>
                        
                        <div className="mt-5 text-sm text-fade">
                            This usually takes up to 24 hours
                        </div>
                        
                        {/* 
                        <div className="w-full mt-3">
                            <ButtonLoader type="button" loading={false} className="btn btn-ep-primary btn-block btn-lg">
                                Close
                            </ButtonLoader>
                        </div>
                         */}
                        
                    </div>
                </div>
            </div>
            
        </div>
    )
}


export default ApprovalPending;